import { useCallback } from "react";
import { useWorkflowForm } from "../context/workflows-editor-workflows-context";


/**
 * Hook to remove a node and all its downstream dependencies (cascading deletion).
 *
 * Example: [node1] -edge1-> [node2] -edge2-> [node3]
 * Removing node2 will also remove edge1, edge2, and node3
 */
export function useRemoveNode() {
  const form = useWorkflowForm();

  const removeNode = useCallback((nodeId: string) => {
    const workflow = form.getValues("workflow");

    if (!workflow) {
      return;
    }

    const nodes = workflow.definition.nodes;
    const edges = workflow.definition.edges;

    const nodesToRemove = new Set<string>();
    const collectDownstreamNodes = (currentNodeId: string) => {
      nodesToRemove.add(currentNodeId);

      const outgoingEdges = edges.filter(edge => edge.source === currentNodeId);

      outgoingEdges.forEach(edge => {
        if (!nodesToRemove.has(edge.target)) {
          collectDownstreamNodes(edge.target);
        }
      });
    };

    collectDownstreamNodes(nodeId);

    const updatedNodes = nodes.filter(node => !nodesToRemove.has(node.id));
    const updatedEdges = edges.filter(
      edge => !nodesToRemove.has(edge.source) && !nodesToRemove.has(edge.target),
    );

    form.setValue("workflow.definition.nodes", updatedNodes, { shouldDirty: true });
    form.setValue("workflow.definition.edges", updatedEdges, { shouldDirty: true });

  }, [form]);

  return { removeNode };
}
